module.exports = __webpack_public_path__ + "images/Coupa-63452d.png";